import { Button } from 'antd'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { poppins } from '@/components/common/fonts'

export const UploadedOrRecorded: FC<{
  audioScriptUrl?: string
  audioScriptFile?: File
  onDelete: () => void
}> = ({ audioScriptUrl, audioScriptFile, onDelete }) => {
  const { t } = useTranslation('common')

  const [url, setUrl] = useState<string>()

  useEffect(() => {
    let objectUrl = ''

    if (!!audioScriptFile) {
      console.log('created url')
      objectUrl = URL.createObjectURL(audioScriptFile)
      setUrl(objectUrl)
    } else if (!!audioScriptUrl) {
      setUrl(audioScriptUrl)
    }

    return () => {
      if (!!objectUrl) {
        console.log('revoked url')
        URL.revokeObjectURL(objectUrl)
      }
    }
  }, [audioScriptUrl, audioScriptFile])

  return (
    <UploadedContainer>
      <audio src={url} controls />
      <DeleteButton type="primary" danger onClick={onDelete}>
        {t('Delete')}
      </DeleteButton>
    </UploadedContainer>
  )
}

const UploadedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  justify-content: center;

  height: 100%;
`

const DeleteButton = styled(Button)`
  height: 40px;
  padding-inline: 48px;

  font-family: ${poppins.string};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #ffffff;

  && {
    background-color: #e00751;
  }
`
